import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "./AuthService";
import {Injectable} from "@angular/core";
import {apiconfig} from "../app/api.config";
import {Observable} from "rxjs";
import {HomeKpi} from "../model/HomeKpi";
import {LogaFieldTeamActivityReport} from "../model/kpi-data";
import {BudgetQuotaConsumptionReport, CustomerSectorHourQuotaReport} from "../model/CustomerSectorHourQuotaReport";

@Injectable()
export class KpiService {

  apiConfig: any = apiconfig;

  constructor(protected http: HttpClient, public authService: AuthService) {
  }

  /**
   *
   * @param operationId
   */
  loadQuotaReport(operationId: number): Promise<CustomerSectorHourQuotaReport> {
    let h = this.authService.getHttpAuth();

    let httpParams = new HttpParams();
    if (operationId && operationId > 0)
      httpParams = httpParams.append("operation", operationId + "");

    return this.http
      .get(this.apiConfig.API_URL + '/order/hour-quota-report', {
        headers: h,
        params: httpParams
      }).map((res: any) => res).toPromise();
  }

  /**
   *
   * @param id
   */
  loadXlsQuotaReport(id: number): Promise<string> {
    let h = this.authService.getHttpAuth();
    return this.http
      .get(this.apiConfig.API_URL + '/order/hour-quota-report-excel?operation=' + id, {headers: h}).map((uuid: string) => {


        let baseUrl = this.apiConfig.API_URL.substring(0, this.apiConfig.API_URL.length - "/api".length);
        console.log(baseUrl);

        return baseUrl + '/dmz/sandbox/' + uuid;
      }).toPromise();
  }

  loadBUdgetQuotaReport(operationId: number): Promise<BudgetQuotaConsumptionReport> {
    let h = this.authService.getHttpAuth();

    let httpParams = new HttpParams();
    if (operationId && operationId > 0)
      httpParams = httpParams.append("operation", operationId + "");

    return this.http
      .get(this.apiConfig.API_URL + '/order/budget-quota-report', {
        headers: h,
        params: httpParams
      }).map((res: any) => res).toPromise();
  }


  loadXlsBudgetQuotaReport(id: number): Promise<string> {
    let h = this.authService.getHttpAuth();
    return this.http
      .get(this.apiConfig.API_URL + '/order/budget-quota-report-excel?operation=' + id, {headers: h}).map((uuid: string) => {


        let baseUrl = this.apiConfig.API_URL.substring(0, this.apiConfig.API_URL.length - "/api".length);
        console.log(baseUrl);

        return baseUrl + '/dmz/sandbox/' + uuid;
      }).toPromise();
  }


  /**
   * @param id
   */
  loadNbDash(): Promise<number> {
    let h = this.authService.getHttpAuth();
    return this.http
      .get(this.apiConfig.API_KPI + '/standard/nb-quota-kpis', {headers: h}).map((res: any) => res).toPromise();
  }

  /**
   * load the OrderActivityReport for a given operation
   */
  loadFieldTeamActivityReport(operationId: number): Promise<LogaFieldTeamActivityReport> {
    let h = this.authService.getHttpAuth();
    return this.http.get(this.apiConfig.API_KPI + '/operation-reports/' + operationId + '/field-team-activity-report', {headers: h}).map((res: any) => res).toPromise();
  }


  /**
   * @param id
   */
  loadHomeKpiSheet(operationId: number): Promise<HomeKpi[]> {
    let h = this.authService.getHttpAuth();
    return this.http.get<HomeKpi[]>(this.apiConfig.API_KPI + '/home-kpi/' + operationId, {headers: h}).toPromise();
  }

  /**
   * @param id
   */
  loadHomeKpi(operationId: number): Observable<HomeKpi[]> {

    return Observable.create(obs => {

      let homeKpis: HomeKpi[] = [];

      let h = this.authService.getHttpAuth();

      this.http
        .get<any[]>(this.apiConfig.API_KPI + '/home-kpi/' + operationId, {headers: h})
        .subscribe(response => {
            if (response) {
              for (let i = 0; i < response['length']; i++) {
                homeKpis.push(HomeKpi.fromJson(response[i]));
              }
              obs.next(response);
              obs.complete();
            }
          },
          (error) => {
            // TODO :
          })
      ;

    });

  }


}



// WEBPACK FOOTER //
// ./src/services/KpiService.ts